export class CircleSearch {
    constructor(mapAdapter, map, mediator) {
        this.mapAdapter = mapAdapter;
        this.map = map;
        this.mediator = mediator;

        this.active = false;
        this.isDragging = false;
        this.eventListeners = [];
        this.circleCenter = null;
        this.circleRadius = null;

        this.setActive(true);
    }

    _initListeners() {
        // MouseDown, MouseMove, MouseUp usw registrieren
        this.eventListeners.push(
            this.mapAdapter.addListener(this.map, 'mousedown', (ev) => this._onMouseDown(ev)),
            this.mapAdapter.addListener(this.map, 'mousemove', (ev) => this._onMouseMove(ev)),
            this.mapAdapter.addListener(this.map, 'mouseup', (ev) => this._onMouseUp(ev))
        );
    }

    _onMouseDown(ev) {
        if ((ev.domEvent.ctrlKey && ev.domEvent.buttons === 1) || ev.domEvent.buttons === 2) {
            this.circleCenter = ev.latLng;
            this.map.setOptions({draggable: false});
            this.isDragging = true;
        }
    }

    _onMouseMove(ev) {
        if(this.isDragging) {
            if(!this.circleCenter) {
                this.circleCenter = ev.latLng;
            }
            this.circleRadius = this.mapAdapter.getDistance(this.circleCenter, ev.latLng);
            this.circle.setCenter(this.circleCenter);
            this.circle.setRadius(this.circleRadius);
        }
    }

    _onMouseUp(ev) {
        if(this.isDragging) {
            if(ev.latLng.equals(this.circleCenter)) {
                this.circleCenter = null;
                this.circleRadius = null;
                this.circle.setCenter(null);
                this.circle.setRadius(null);
            }
            this.mediator.publish("circlesearch:trigger", {
                center: this.circleCenter,
                radius: this.circleRadius
            });
            this.isDragging = false;
            this.map.setOptions({draggable: true});
        }
    }

    getCircle() {
        return this.circle;
    }

    createCircle() {
        this.circle = this.mapAdapter.createCircle({
            fillColor: '#c356a0',
            strokeColor: '#c356a0',
            map: this.map,
            clickable: false
        });
    }

    setCircle(center, radius) {
        this.circle.setCenter(center);
        this.circle.setRadius(radius);
        this.circleCenter = center;
        this.circleRadius = radius;
    }

    deleteCircle(){
        if(this.circle) { this.circle.setMap(null); }
    }

    setActive(activeState = true) {
        if(activeState === this.active) { return; }
        if(activeState) {
            this.createCircle();
            this._initListeners();
        } else {
            if(this.circle) { this.circle.setMap(null); }
            this._removeListeners();
        }
        this.active = activeState;
    }

    _removeListeners() {
        for(const listener of this.eventListeners){
            this.mapAdapter._removeListener(listener);
        }
        this.eventListeners = [];
    }
}